
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jHois", function(module, exports) {

var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");


var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

const $e3adf083a3ceeb07$export$3cf4b7499c49a1bc = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY)
});
const $e3adf083a3ceeb07$export$f38e95ed03e5cac6 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_INTERACTION)
});
const $e3adf083a3ceeb07$export$fe68f7d0c5f4b391 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION)
});
const $e3adf083a3ceeb07$export$f35c906f54c0512a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.PAGE_ANALYTICS_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$aa2d84a67f31f760 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SPACE_ANALYTICS_PAGE_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$73b0f2ef62226204 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SITE_ANALYTICS_LOAD_KEY)
});
module.exports["CONTENT_ANALYTICS_VIEWERS_METRIC"] = $e3adf083a3ceeb07$export$3cf4b7499c49a1bc;
module.exports["CONTENT_ANALYTICS_DIALOG_METRIC"] = $e3adf083a3ceeb07$export$f38e95ed03e5cac6;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_METRIC"] = $e3adf083a3ceeb07$export$fe68f7d0c5f4b391;
module.exports["PAGE_ANALYTICS_PAGE_LOAD_METRIC"] = $e3adf083a3ceeb07$export$f35c906f54c0512a;
module.exports["SPACE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$aa2d84a67f31f760;
module.exports["SITE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$73b0f2ef62226204;

});

parcelRegister("pG0Ei", function(module, exports) {
var $8787696ab5570b52$export$b8ca5fa4899cbfc7 = /*#__PURE__*/ function(AccountType) {
    AccountType["NORMAL"] = "normal";
    AccountType["GUEST"] = "guest";
    AccountType["ANONYMOUS"] = "anonymous";
    return AccountType;
}({});
module.exports["AccountType"] = $8787696ab5570b52$export$b8ca5fa4899cbfc7;

});

parcelRegister("5Rd17", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2QrXF = parcelRequire("2QrXF");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $6gGPb = parcelRequire("6gGPb");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");










const $bba20334be910b9f$export$e23ae35269442b4f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { label: t1, size: t2 } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? 16 : t2;
    const clipId = (0, $cozmU.useId)();
    const t3 = label ? "img" : "presentation";
    const t4 = label || undefined;
    const t5 = label ? undefined : true;
    const t6 = `url(#${clipId})`;
    let t10;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
            fill: "#1868DB"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
            fill: "#6A9A23"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
            fill: "#AF59E1"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
            fill: "#FCA700"
        });
        $[0] = t10;
        $[1] = t7;
        $[2] = t8;
        $[3] = t9;
    } else {
        t10 = $[0];
        t7 = $[1];
        t8 = $[2];
        t9 = $[3];
    }
    let t11;
    if ($[4] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: t6
        }, t7, t8, t9, t10);
        $[4] = t6;
        $[5] = t11;
    } else t11 = $[5];
    let t12;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white"
        });
        $[6] = t12;
    } else t12 = $[6];
    let t13;
    if ($[7] !== clipId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: clipId
        }, t12));
        $[7] = clipId;
        $[8] = t13;
    } else t13 = $[8];
    let t14;
    if ($[9] !== size || $[10] !== t11 || $[11] !== t13 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: size,
            height: size,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: t3,
            "aria-label": t4,
            "aria-hidden": t5
        }, t11, t13);
        $[9] = size;
        $[10] = t11;
        $[11] = t13;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t14;
    } else t14 = $[15];
    return t14;
} : ({ label: label = '', size: size = 16 })=>{
    const clipId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
        fill: "#AF59E1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
        fill: "#FCA700"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $4580118d363597fd$export$8f1cb3c7f8edc6be = (0, $kSwu1.defineMessages)({
    expandAgentRow: {
        id: "confluence-analytics.agent-activity.expand-agent-row",
        defaultMessage: "Show the people who used this agent"
    },
    collapseAgentRow: {
        id: "confluence-analytics.agent-activity.collapse-agent-row",
        defaultMessage: "Hide the people who used this agent"
    },
    agentSubtitle: {
        id: "confluence-analytics.agent-activity.agent-subtitle",
        defaultMessage: "with {name}{count, plural, =0 {} one { and # other} other { and # others}}"
    }
});
const $4580118d363597fd$var$styles = {
    toggle: "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf _vchhusvi _ahbqv77o _12l2v77o _bfhksm61",
    childIndent: "_bozg1jfw",
    iconWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf _ahbqv77o _12l2v77o"
}; /**
    * Renders an agent row's leading icon: the fixed AiAgent/Rovo icon for agents that
    * couldn't be resolved to an account, otherwise the deterministic hexagon AgentAvatar.
    */ 
const $4580118d363597fd$export$951877a280bbd2e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { name: name, agentIcon: agentIcon } = t0;
    if (agentIcon === "ai-agent") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $4580118d363597fd$var$styles.iconWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
                label: "",
                appearance: "gray",
                size: "small"
            }));
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if (agentIcon === "rovo") {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $4580118d363597fd$var$styles.iconWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bba20334be910b9f$export$e23ae35269442b4f), {
                label: "",
                size: 24
            }));
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $4580118d363597fd$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            size: "small",
            name: name,
            label: ""
        }));
        $[2] = name;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ name: name, agentIcon: agentIcon })=>{
    if (agentIcon === 'ai-agent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $4580118d363597fd$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        label: "",
        appearance: "gray",
        size: "small"
    }));
    if (agentIcon === 'rovo') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $4580118d363597fd$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bba20334be910b9f$export$e23ae35269442b4f), {
        label: "",
        size: 24
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $4580118d363597fd$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        size: "small",
        name: name,
        label: ""
    }));
}; /**
    * The agent's hexagon avatar doubles as the expand affordance: on hover or keyboard
    * focus it swaps to a chevron, and clicking it toggles the nested child rows. Keeping
    * the toggle on the avatar itself (rather than a separate inline control) matches the
    * design.
    */ 
const $4580118d363597fd$export$f483be08076d9dad = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { name: name, isExpanded: isExpanded, onToggle: onToggle, expandLabel: expandLabel, collapseLabel: collapseLabel, agentIcon: agentIcon } = t0;
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    const showChevron = isActive || isExpanded;
    const t1 = isExpanded ? collapseLabel : expandLabel;
    let t2;
    if ($[0] !== onToggle) {
        t2 = (event)=>{
            event.stopPropagation();
            onToggle();
        };
        $[0] = onToggle;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsActive(true);
        t4 = ()=>setIsActive(false);
        t5 = ()=>setIsActive(true);
        t6 = ()=>setIsActive(false);
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else {
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] !== agentIcon || $[7] !== isExpanded || $[8] !== name || $[9] !== showChevron) {
        t7 = showChevron ? isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
            name: name,
            agentIcon: agentIcon
        });
        $[6] = agentIcon;
        $[7] = isExpanded;
        $[8] = name;
        $[9] = showChevron;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== isExpanded || $[12] !== t1 || $[13] !== t2 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            xcss: $4580118d363597fd$var$styles.toggle,
            "aria-label": t1,
            "aria-expanded": isExpanded,
            onClick: t2,
            onMouseEnter: t3,
            onMouseLeave: t4,
            onFocus: t5,
            onBlur: t6
        }, t7);
        $[11] = isExpanded;
        $[12] = t1;
        $[13] = t2;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ name: name, isExpanded: isExpanded, onToggle: onToggle, expandLabel: expandLabel, collapseLabel: collapseLabel, agentIcon: agentIcon })=>{
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    const showChevron = isActive || isExpanded;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        xcss: $4580118d363597fd$var$styles.toggle,
        "aria-label": isExpanded ? collapseLabel : expandLabel,
        "aria-expanded": isExpanded,
        onClick: (event)=>{
            event.stopPropagation();
            onToggle();
        },
        onMouseEnter: ()=>setIsActive(true),
        onMouseLeave: ()=>setIsActive(false),
        onFocus: ()=>setIsActive(true),
        onBlur: ()=>setIsActive(false)
    }, showChevron ? isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
        name: name,
        agentIcon: agentIcon
    }));
}; /**
    * Renders the name-column cell for an AI-agent row: the hexagon AgentAvatar (which
    * doubles as an expand toggle when the agent has child rows) plus an optional subtitle.
    * The consuming table supplies `name`/`subtitle` from its own row model.
    */ 
const $4580118d363597fd$export$6bb3a1031846604c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { name: name, subtitle: subtitle, isExpandable: isExpandable, isExpanded: isExpanded, onToggleExpand: onToggleExpand, agentIcon: agentIcon } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== agentIcon || $[1] !== formatMessage || $[2] !== isExpandable || $[3] !== isExpanded || $[4] !== name || $[5] !== onToggleExpand) {
        t1 = isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$f483be08076d9dad, {
            name: name,
            isExpanded: Boolean(isExpanded),
            onToggle: onToggleExpand,
            expandLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.expandAgentRow),
            collapseLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.collapseAgentRow),
            agentIcon: agentIcon
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
            name: name,
            agentIcon: agentIcon
        });
        $[0] = agentIcon;
        $[1] = formatMessage;
        $[2] = isExpandable;
        $[3] = isExpanded;
        $[4] = name;
        $[5] = onToggleExpand;
        $[6] = t1;
    } else t1 = $[6];
    const avatar = t1;
    let t2;
    if ($[7] !== avatar || $[8] !== name || $[9] !== subtitle) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2QrXF.default), {
            avatar: avatar,
            primaryText: name,
            secondaryText: subtitle
        });
        $[7] = avatar;
        $[8] = name;
        $[9] = subtitle;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ name: name, subtitle: subtitle, isExpandable: isExpandable, isExpanded: isExpanded, onToggleExpand: onToggleExpand, agentIcon: agentIcon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const avatar = isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$f483be08076d9dad, {
        name: name,
        isExpanded: Boolean(isExpanded),
        // useExpandableAgentRows), so it can be passed through directly.
        onToggle: onToggleExpand,
        expandLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.expandAgentRow),
        collapseLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.collapseAgentRow),
        agentIcon: agentIcon
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
        name: name,
        agentIcon: agentIcon
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2QrXF.default), {
        avatar: avatar,
        primaryText: name,
        secondaryText: subtitle
    });
}; /** Wraps an agent's nested child (person) cell with a left indent. */ 
const $4580118d363597fd$export$bf2de6dc20683668 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $4580118d363597fd$var$styles.childIndent
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $4580118d363597fd$var$styles.childIndent
    }, children); /**
                                                                           * Owns expand/collapse state and flattens parent rows into the array handed to the
                                                                           * table: each expanded agent's children are spliced directly beneath it, so sorting
                                                                           * and pagination (done by the caller) only ever act on the parent rows.
                                                                           */ 
const $4580118d363597fd$export$3083e75456a22336 = (0, $3u0dr.isReactCompilerActiveV2)() ? (parentRows, childrenByAgentId)=>{
    const $ = (0, $bDgLe.c)(5);
    const [expandedAgentIds, setExpandedAgentIds] = (0, $cozmU.useState)($4580118d363597fd$var$_temp);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (agentId)=>{
            setExpandedAgentIds((previous)=>{
                const next = new Set(previous);
                if (next.has(agentId)) next.delete(agentId);
                else next.add(agentId);
                return next;
            });
        };
        $[0] = t0;
    } else t0 = $[0];
    const toggleAgentExpansion = t0;
    let rows;
    if ($[1] !== childrenByAgentId || $[2] !== expandedAgentIds || $[3] !== parentRows) {
        rows = [];
        parentRows.forEach((row)=>{
            const { isAgent: isAgent, isExpandable: isExpandable, agentId: agentId_0 } = row.data;
            if (isAgent && isExpandable && agentId_0) {
                const isExpanded = expandedAgentIds.has(agentId_0);
                rows.push({
                    ...row,
                    data: {
                        ...row.data,
                        isExpanded: isExpanded,
                        onToggleExpand: ()=>toggleAgentExpansion(agentId_0)
                    }
                });
                if (isExpanded) rows.push(...childrenByAgentId[agentId_0] ?? []);
            } else rows.push(row);
        });
        $[1] = childrenByAgentId;
        $[2] = expandedAgentIds;
        $[3] = parentRows;
        $[4] = rows;
    } else rows = $[4];
    return rows;
} : (parentRows, childrenByAgentId)=>{
    const [expandedAgentIds, setExpandedAgentIds] = (0, $cozmU.useState)(()=>new Set());
    const toggleAgentExpansion = (0, $cozmU.useCallback)((agentId)=>{
        setExpandedAgentIds((previous)=>{
            const next = new Set(previous);
            if (next.has(agentId)) next.delete(agentId);
            else next.add(agentId);
            return next;
        });
    }, []);
    return (0, $cozmU.useMemo)(()=>{
        const rows = [];
        parentRows.forEach((row)=>{
            const { isAgent: isAgent, isExpandable: isExpandable, agentId: agentId_0 } = row.data;
            if (isAgent && isExpandable && agentId_0) {
                const isExpanded = expandedAgentIds.has(agentId_0);
                rows.push({
                    ...row,
                    data: {
                        ...row.data,
                        isExpanded: isExpanded,
                        onToggleExpand: ()=>toggleAgentExpansion(agentId_0)
                    }
                });
                if (isExpanded) rows.push(...childrenByAgentId[agentId_0] ?? []);
            } else rows.push(row);
        });
        return rows;
    }, [
        parentRows,
        childrenByAgentId,
        expandedAgentIds,
        toggleAgentExpansion
    ]);
};
const $4580118d363597fd$export$24e644fa464a5e9f = (formatMessage, name, count)=>formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.agentSubtitle, {
        name: name,
        count: count
    });
function $4580118d363597fd$var$_temp() {
    return new Set();
}
module.exports["agentActivityI18n"] = $4580118d363597fd$export$8f1cb3c7f8edc6be;
module.exports["AgentRowAvatar"] = $4580118d363597fd$export$951877a280bbd2e;
module.exports["AgentActivityNameCell"] = $4580118d363597fd$export$6bb3a1031846604c;
module.exports["AgentChildRowIndent"] = $4580118d363597fd$export$bf2de6dc20683668;
module.exports["useExpandableAgentRows"] = $4580118d363597fd$export$3083e75456a22336;
module.exports["getAgentSubtitle"] = $4580118d363597fd$export$24e644fa464a5e9f;

});


//# sourceMappingURL=AnalyticsByLine.312f612b.js.map
